import React, { useEffect } from 'react';
import s from './Notification.module.scss';
import ProfileMenuHeader from 'modules/app/components/ProfileMenu/ProfileMenuHeader';
import { useNavigate } from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetNotifications from 'sdk/hooks/useGetNotifications';
import { useActions } from 'store/useActions';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
};

const formatTime = (timeString) => {
    const [hours, minutes, seconds] = timeString?.split(':');
    const date = new Date();
    date?.setHours(hours, minutes, seconds);

    return date?.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });
};

const Notification = () => {
    const navigate = useNavigate();
    const { data: isAuthData } = useIsAuth();
    const userId = isAuthData?.user?.id;
    const { setIsSlideChange } = useActions()

    const { data: notifications } = useGetNotifications(userId);

    useEffect(() => {
        setIsSlideChange(false)
 
    }, [])

       

    return (
        <div className={s.notification}>
            <ProfileMenuHeader
                onClose={() => navigate(-1)}
                text={'Notifications'}
            />
            <div className={s.date_title}>Today</div>
            {notifications?.filter(el => el.type === "booking")?.map((item) => {
                return (
                    <div className={s.booking}>
                        <div className={s.booking_header}>
                            <div className={s.booking_header_left}>
                                <img className={s.booking_header_left_img} src={item?.booking_transactions?.services?.image} />
                                <div className={s.booking_header_left_title}>{item?.booking_transactions?.services?.name}</div>
                            </div>
                            <div className={s.booking_header_right}>
                                <div className={s.booking_header_right_date}>{formatDate(item?.booking_transactions?.date ?? "")}</div>
                                <div className={s.booking_header_right_time}>{formatTime(item?.booking_transactions?.start_time ?? "")}</div>
                            </div>
                        </div>
                        <div className={s.booking_name}>{item?.booking_transactions?.services?.menu_category?.name}</div>
                        <div className={s.booking_message}>{item?.message}</div>
                    </div>
                )
            })}

            <div className={s.date_title}>Yesterday</div>
            {notifications?.filter(el => el.type === "order")?.map((item) => {
                const product = item?.products
                return (
                    <div className={s.product}>
                        <img src={product?.image} className={s.product_image} alt="" />
                        <div className={s.product_inf}>
                            <div className={s.product_inf_header}>
                                <div className={s.product_inf_header_name}>
                                    {product?.name}
                                </div>
                                <div className={s.product_inf_header_price}>
                                    ${product?.sale_price}
                                </div>
                            </div>
                            <div className={s.product_inf_body}>
                                <div className={s.product_inf_body_first}>Sold by @Nailubob</div>
                                <div className={s.product_inf_body_second}>Shipping from USA</div>
                            </div>
                            <div className={s.product_inf_footer}>
                                {item?.message}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default Notification;
